import axios from "axios";
import Cookies from "js-cookie";
// export const base_url = "http://43.204.99.206/";
// export const base_url = "https://myburgo.com/api";
export const isProduction = process.env.REACT_APP_IS_PRODUCTION === "true";
const isLocal = process.env.REACT_APP_IS_LOCAL === "true";

export const base_url = isLocal
  ? "http://localhost:8000/"
  : isProduction
    ? "https://prod.myburgo.com/"
    : "https://api.myburgo.com/";

export const open_api = axios.create({
  baseURL: base_url,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
  validateStatus: (status) => status < 500,
  transformRequest: [
    function (data, headers) {
      return JSON.stringify(data);
    },
  ],
});

let logoutHandler = null;

export const registerLogoutHandler = (fn) => {
  logoutHandler = fn;
};

export const open_api_with_cookies = axios.create({
  baseURL: base_url,
  timeout: 300000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "X-Platform": "Web",
  },
  validateStatus: (status) => status >= 200 && status < 300,
  transformRequest: [
    function (data, headers) {
      if (!(data instanceof FormData)) {
        headers["Content-Type"] = "application/json";
        return JSON.stringify(data);
      }
      return data; // for FormData, return as-is and do NOT set Content-Type
    },
  ],
});

open_api_with_cookies.interceptors.request.use(
  (config) => {
    const csrfToken = Cookies.get("csrftoken");

    // Only add CSRF token for unsafe methods
    const unsafeMethods = ["post", "put", "patch", "delete"];
    if (csrfToken && unsafeMethods.includes(config.method.toLowerCase())) {
      config.headers["X-CSRFToken"] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

open_api_with_cookies.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const isUnauthenticated =
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/refresh-cookie/");

    if (isUnauthenticated) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await axios.post(
          `${base_url}auth/refresh-cookie/`,
          {},
          { withCredentials: true }
        );

        if (refreshResponse.status === 200) {
          await new Promise((resolve) => setTimeout(resolve, 100)); // give cookie time to settle
          return open_api_with_cookies(originalRequest);
        } else {
          if (logoutHandler) logoutHandler(); // Trigger logout if refresh failed
        }
      } catch (err) {
        console.error("Token refresh failed:", err);
        if (logoutHandler) logoutHandler(); // Logout on refresh failure
      }
    }

    return Promise.reject(error);
  }
);

export const open_api_with_user_token = (token) =>
  axios.create({
    baseURL: base_url,
    timeout: 300000,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": `application/json`,
    },
    validateStatus: (status) => status < 500,
    transformRequest: [
      function (data, headers) {
        return JSON.stringify(data);
      },
    ],
  });

export const open_api_without_auth = axios.create({
  baseURL: base_url,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
    "X-Platform": "Web",
  },
  validateStatus: (status) => status < 500,
  transformRequest: [
    function (data, headers) {
      return JSON.stringify(data);
    },
  ],
});

export const getCountryCode = async () => {
  let countryCode = sessionStorage.getItem("country_code");

  if (!countryCode) {
    try {
      const response = await axios.get("https://ipapi.co/json/");
      countryCode = response.data.country_code.toLowerCase();
      sessionStorage.setItem("country_code", countryCode);
    } catch (error) {
      console.error("Error fetching the country code", error);
      countryCode = "in";
      sessionStorage.setItem("country_code", countryCode);
    }
  }

  return countryCode;
};

getCountryCode();
